import { rem } from 'polished';
import * as React from 'react';
import styled from 'styled-components';
import { mediaQueryWidth } from '../../common/breakpoints';
import { StyledPaddingContainer } from '../../common/padding.styles';
import { FeaturedTitle } from '../../components/featured-title/FeaturedTitle';
import { HeadTitle } from '../../components/head-title/HeadTitle';
import { ImageCards } from '../../components/image-cards/ImageCards';
import { ImageCardProps } from '../../components/image-cards/ImageCards.props';
import { Img } from '../../components/img/Img';
import { DefaultLayout } from '../../layout/default/DefaultLayout';
import bannerImage from '../US/assets/images/banner.jpg';
import dcShopImage from '../US/assets/images/dc-shop.jpg';
import wbShopImage from '../US/assets/images/wb-shop.jpg';

const cards: ImageCardProps[] = [
  {
    alt: 'WB Shop',
    src: wbShopImage,
    subtitle: 'Check out the latest collections from Friends to Rick & Morty',
    title: 'WB Shop',
    to:
      'https://wbshop.com/?utm_source=warnerbros.com/shop&utm_medium=referral' +
      '&utm_campaign=warnerbroscom-referral&utm_term=warnerbros&utm_content=content-site',
  },
  {
    alt: 'DC Shop',
    src: dcShopImage,
    subtitle: 'Don’t miss the latest collections from our heroes & villains',
    title: 'DC Shop',
    to: 'https://shop.dc.com/shop?utm_source=WarnerBros&utm_medium=Website&utm_campaign=Referral2021',
  },
];

const StyledImageContainer = styled.div`
  position: relative;
  margin-bottom: ${rem(20)};
  line-height: 0;

  & > img {
    min-height: ${rem(200)};
  }

  & > section {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: auto;
    z-index: 2;
    background: none;
  }

  ${mediaQueryWidth({ min: 'tablet' })`
    margin-bottom: ${rem(40)};
  `}
`;

export default () => (
  <DefaultLayout locale='en-US'>
    <HeadTitle title='Shop' />
    <StyledImageContainer>
      <Img alt='Our Shops' src={bannerImage} />
      <FeaturedTitle title='Our Shops' />
    </StyledImageContainer>
    <StyledPaddingContainer>
      <ImageCards cards={cards} ratio={0.8} />
    </StyledPaddingContainer>
  </DefaultLayout>
);
